// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('popover_confirmation_public_boards');

// eslint-disable-next-line @trello/no-module-logic
export const PopoverConfirmationPublicBoardsTemplate = t.renderable(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ isTemplate }: any) =>
    t.div('.public-board-confirmation-popover', function () {
      t.div('.public-board-confirmation-popover-title', function () {
        if (isTemplate) {
          t.span(() => t.format('public-template-confirmation-description'));

          return t.button(
            '.js-submit.wide.nch-button.nch-button--primary.full.make-public-confirmation-button',
            () => t.format('public-template-confirm'),
          );
        } else {
          t.span(() => t.format('public-board-confirmation-description'));

          return t.button(
            '.js-submit.wide.nch-button.nch-button--primary.full.make-public-confirmation-button',
            () => t.format('confirm'),
          );
        }
      });

      t.hr();

      return t.div('.public-board-confirmation-popover-invitation-link', () =>
        t.p(function () {
          t.format('looking-for-share-link-create-one');
          t.a(
            '.js-action-link.looking-for-share-link-create-one',
            { href: '#', target: '_blank' },
            function () {
              return t.format('open-share-menu');
            },
          );
        }),
      );
    }),
);
